<template>
  <div>
    <v-container grid-list-md>
      <v-card>
        <v-card-text>
          <v-layout align-center justify-start row fill-height>
            <v-radio-group v-model="value.type" :mandatory="true" row>
              <div slot="label">サーベイタイプ</div>
              <v-radio label="本人" value="subject"></v-radio>
              <v-radio label="協力者" value="coWorker"></v-radio>
            </v-radio-group>
          </v-layout>
          <v-layout align-center justify-start row fill-height>
            <v-flex md5>
              <v-select
                v-model="subject"
                :items="usersArray"
                item-text="name"
                item-value="id"
                label="対象者"
                return-object
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-start row fill-height>
            <v-flex md1>性別: {{subject.sex}}</v-flex>
            <v-flex md2>生年月日: {{toDate(subject.birth)}}</v-flex>

            <v-flex md3>職種:{{subject.job}}</v-flex>
            <v-flex md2>役職:{{subject.position}}</v-flex>
          </v-layout>
          <v-layout
            align-center
            justify-start
            row
            fill-height
            v-show="value.type=='coWorker'"
          >
            <v-flex xs10 md5>
              <v-text-field v-model="value.name" :rules="nameRules" label="協力者名" required></v-text-field>
            </v-flex>
            <v-flex xs10 md5>
              <v-text-field
                v-model="value.email"
                :rules="emailRules"
                label="協力者 E-mail"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="createAnswer">追加</v-btn>

          <v-btn @click="closeDialog">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" fullscreen>
      <v-card tile>
        <v-toolbar card color="indigo" class="white--text" dark>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>職種選択</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field v-model="search" label="検索"></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              class="elevation-1"
              :pagination.sync="pagination"
              rows-per-page-text="表示行"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="items" slot-scope="props">
                <tr @click.stop="selectJob(props.item)">
                  <td class="text-xs-left">{{ props.item.id }}</td>
                  <td class="text-xs-left">{{ props.item.category }}</td>
                  <td class="text-xs-left">{{ props.item.subcategory }}</td>
                  <td class="text-xs-left">{{ props.item.subsubcategory }}</td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                </tr>
              </template>
              <template
                slot="pageText"
                slot-scope="props"
              >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import jobs from "@/master/jobs.json";
import { unixtimeToJapaneseFormattedDate } from "@/utils/datetime.js";
export default {
  components: {},
  props: {
  
      value: {
        type: Object,
        default: null
      },

  },
  data() {
    return {
      userDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("users"),
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      users: {},
      usersArray: [],
      subject: {},
      search: "",
      dialog: false,
      items: [],
      headers: [
        {
          text: "コード",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "大分類",
          align: "left",
          sortable: false,
          value: "category"
        },
        {
          text: "中分類",
          align: "left",
          sortable: false,
          value: "subcategory"
        },
        {
          text: "小分類",
          align: "left",
          sortable: false,
          value: "subsubcategory"
        },
        {
          text: "業種名",
          align: "left",
          sortable: false,
          value: "name"
        }
      ],
      keysCopyToAnswer:[ 'job', 'job_id', 'position'],
      file: null,
      pagination: {
        rowsPerPage: 50
      },
      rowsPerPageItems: [25, 50, 100],
      search: "",
      nameRules: [v => !!v || "必須事項です"],
      emailRules: [
        v => !!v || "必須事項です",
        v => /.+@.+/.test(v) || "E-mailの形式ではありません。"
      ]
    };
  },
  watch: {},
  mounted() {
    this.getUsers();
    this.items = jobs;
  },
  computed: {},
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    addItem() {
      this.$emit("createItem");
    },
    updateItem() {
      this.$emit("updateItem");
    },
    selectJob(job) {
      this.value.job = job.name;
      this.value.job_id = job.id;
      this.dialog = false;
    },
    async getUsers() {
      this.users = {};
      this.usersArray = [];
      const querySnapshot = await this.userDbRef.get();
      querySnapshot.forEach(doc => {
        const user = doc.data();
        this.users[doc.id] = { ...user, id: doc.id };
        this.usersArray.push({ ...user, id: doc.id });
      });
    },
    toDate(unixtime) {
      return Number.isInteger(unixtime)
        ? unixtimeToJapaneseFormattedDate(unixtime)
        : "";
    },
    async createAnswer() {
      this.value.subject_id = this.subject.id;
      this.value.subject_name = this.subject.name;
      for(let key of this.keysCopyToAnswer){
        this.value[key] = this.subject[key]
      }
      if (this.value.type == "subject") {
        this.value.name = this.subject.name;
        this.value.email = this.subject.email;
        this.value.birthday = 0;
      }
      try {
        await this.answerDbRef.add(this.value);
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
